import React from 'react';
import PropTypes from 'prop-types';
import { PrivilegeChecker } from 'omni-common-ui';
import Privileges from 'domain/Privileges';
import TabSwitcher, { TabCodes } from 'domain/TabSwitcher';
import ProgressTest, { mapStateToProps } from './component';
import { actions as Group } from 'containers/Group';

import { routes as progressTestDayView } from './ProgressTestDayView';
import { routes as progressTestCourseView } from './ProgressTestCourseView';
import { routes as progressTestRubricView } from './ProgressTestRubricView';
import ProgressTestRubricViewHFv4 from '../MidtermAndFinalExamHFv4/RubricView/component';
import ViewNav from 'components/ViewNav';
import ProgressTestSessionNav from 'components/ProgressTestSessionNav';
import { accessors as ProgressTests } from 'data/ProgressTests';

// HFv4 Unit Review shares the progress-test URL, but must not sort inside the
// shared ProgressTestRubricView (also mounted by non-HFv4 exam).
const progressTestRubricViewForGroup = ({ getState }) => {
  const route = progressTestRubricView({ getState });
  const ProgressTestRubricViewSwitch = (props) => {
    const View = Group.isHFV4CourseTypeGroup(getState(), props.params.groupId) ?
      ProgressTestRubricViewHFv4 :
      route.component;
    return React.createElement(View, props);
  };
  ProgressTestRubricViewSwitch.propTypes = {
    params: PropTypes.object.isRequired,
  };
  return Object.assign({}, route, {
    component: ProgressTestRubricViewSwitch,
  });
};

export default ({ getState }) => ({
  appBars: {
    sticky: {
      ptNav: {
        component: ProgressTestSessionNav,
        props: {
          isUnitQuiz: true,
        },
        order: 1,
      },
      'view-nav': {
        component: ViewNav,
        props: {
          showExpandable: true,
        },
        order: 3,
      },
    },
  },
  path: 'progress-test',
  component: ProgressTest,
  canAccess: ({ params }) =>
    PrivilegeChecker.hasPrivilege(getState(), Privileges.ProgressTest.View) &&
    TabSwitcher.isTabEnabled(getState(), params.groupId, TabCodes.ProgressTest),
  tab: {
    label: (params) => ProgressTests.getProgressTestTab(getState(), params.groupId),
    order: 6,
    isVisible: (params) =>
      PrivilegeChecker.hasPrivilege(getState(), Privileges.ProgressTest.View) &&
      TabSwitcher.isTabEnabled(getState(), params.groupId, TabCodes.ProgressTest),
  },
  breadcrumbLabels: (props) => {
    const { params: { groupId, progressTestIndex }, buildRoute } = props;
    const currentProps = mapStateToProps(getState(), props);
    if (! currentProps || ! currentProps.currentProgressTestPlan) return;
    const labelName = ProgressTests.getPTNameWithGroup(
      getState(),
      currentProps.currentProgressTestPlan.name,
      groupId);
    return {
      label: labelName,
      href: buildRoute(`/group/${groupId}/progress-test/${progressTestIndex}/course`),
    };
  },
  childRoutes: [
    progressTestDayView,
    progressTestCourseView,
    progressTestRubricViewForGroup,
  ],
});



// WEBPACK FOOTER //
// ./containers/Group/ProgressTest/routes.js